<template>
    <div class="app-nav">
        <el-breadcrumb separator="/" class="breadcrumb">
            <el-breadcrumb-item v-for="(item, index) in pathMap" :key="index">
                <template v-if="(index === 0 && !item.path) || index === pathMap.length-1">{{item.name}}</template>
                <router-link v-else :to="{ path: item.path }">{{item.name}}</router-link>
            </el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 大屏 -->
        <div class="operate-btn monitor-btn" v-if="$i18n.locale==='zh-CN'" @click="toMonitor" title="学员大数据看板">
            <i class="nucfont inuc-online"></i>
        </div>

        <!-- 主题切换 -->
        <el-popover
            class="operate-btn changeTheme"
            trigger="click"
        >
            <div style="display: flex;flex-wrap: wrap;">
                <div v-for="(theme, index) in [
                    ['#282828', '#33363d', '#3b3e47'],
                    ['#00bcd4', '#1b6b83', '#f1f1f1'],
                    ['#053f5e', '#115173', '#022c43'],
                    ['#393e46', '#445065', '#222831'],
                    ['#3C8DBC', '#367FA9', '#304156']]"
                     style="width: 50px;height: 50px;margin-right:10px;cursor: pointer">
                    <p v-for="item in theme" @click="changeTheme(index)"
                       style="height: 33%" :style="{backgroundColor: item}"></p>
                </div>
            </div>
            <span slot="reference" class="operate-btn changeTheme" :title="$t('app.switchTheme')">
                <i class="nucfont inuc-alter"></i>
            </span>
        </el-popover>

        <!-- 新功能展板 -->
        <!-- <app-feature></app-feature> -->

        <!-- 消息通知 -->
        <app-notice></app-notice>
    </div>
</template>

<script>
    import {Storage, Ticket, screenfull} from '@/utils';
    import {mapGetters} from 'vuex';
    import AppNotice from '@/components/App/AppNotice';
    import AppFeature from "@components/App/AppFeature";

    export default {
        components: {
            AppNotice,
            AppFeature
        },

        data() {
            return {
                pathMap: []
            }
        },

        computed: {
            ...mapGetters([
                'appTheme',
                'wsBrowser',
            ]),
        },
        methods: {
            // 监控页
            toMonitor() {
                this.$router.push({name: 'monitorScreen'}).then(() => {
                    screenfull.request()
                })
            },

            changeTheme(theme) {
                this.$store.dispatch('updateAppTheme', theme)
            },
        },
        watch: {
            $route: {
                handler(to, from) {
                    this.menuData = Storage.get('menu');
                    let path = '';
                    this.pathMap = [];

                    to.matched.forEach(matched => {
                        if (this.menuData) {
                            this.menuData.forEach(v => {
                                if (v.path === matched.path) {
                                    this.pathMap.push(v)
                                }

                                if (v.children.length) {
                                    v.children.forEach(item => {
                                        if (item.path === matched.path) {
                                            this.pathMap.push(v, item)
                                        }
                                    })
                                }
                            });
                        }

                        if (matched.parent) {
//                            this.menuData.find(v => {
//                                return v.path === matched.parent.path || v.children.find(a => a.path === matched.parent.path)
//                            })
                            this.pathMap.push({
                                name: matched.meta.title,
                                path: matched.path
                            })
                        }

                    });


                    //console.log(to);
                    //console.log(this.pathMap);
                },
                immediate: true
            }
        },
    }
</script>

<style lang="scss">
    @import '../../style/const';

    .app-nav {
        display: flex;
        position: absolute;
        width: 100%;
        height: $h-nav;
        margin-top: -$h-nav;
        padding-right: 40px;
        z-index: 9;

        .breadcrumb {
            height: $h-nav;
            line-height: $h-nav;
            padding: 0 20px;
            flex: 1;

            .el-breadcrumb__item {
                &:last-child:hover .el-breadcrumb__inner {
                    color: #fff;
                }
            }

            .el-breadcrumb__inner {
                color: #fff!important;

                a {
                    color: #188ae2;
                }

                &.is-link {
                    color: #188ae2;
                }
            }
        }

        .operate-btn {
            width: 50px;
            line-height: $h-nav;
            text-align: center;
            cursor: pointer;
            //overflow: hidden;

            .nucfont {
                color: #fff;
                outline: none;
            }

            &.changeTheme {
                display: block;
                outline: none;
            }

            .el-badge {
                display: block;
                .el-badge__content.is-fixed{
                    padding: 0 6px;
                    top: 10px;
                    right: 20px;
                }
            }
        }
    }
</style>
